export const getStatusColor = (status) => {
  const colors = {
    'active': 'border-green-400 text-green-700 bg-green-50',
    'confirmed': 'border-green-400 text-green-700 bg-green-50',
    'pending': 'border-yellow-400 text-yellow-700 bg-yellow-50',
    'cancelled': 'border-red-400 text-red-700 bg-red-50',
  };
  return colors[status?.toLowerCase()] || 'border-gray-400 text-gray-700 bg-gray-50';
};
